export const setIsOpen = (setValues, values) => {
  setValues({ ...values, isOpen: !values.isOpen })
}
